export default "__VITE_PUBLIC_ASSET__d0f7d572__"